module.exports = __webpack_public_path__ + "img/creador.3df92a35.png";